import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CreateUserForm } from '@/components/create-user-form';
import { Button } from '@/components/ui/button';

export function CreateUserPage() {
  return (
    <section className="w-full space-y-6">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-2">
          <h1 className="text-3xl font-semibold tracking-tight text-foreground">Créer un utilisateur</h1>
          <p className="max-w-2xl text-sm leading-6 text-muted-foreground">
            L’utilisateur recevra un e-mail pour activer son accès.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <Button
            asChild
            variant="outline"
            className="h-12 border-border bg-background px-5 text-[15px] font-medium text-foreground hover:border-foreground/20 hover:bg-muted dark:bg-muted dark:hover:bg-muted/80"
          >
            <Link to="/admin/users">
              <ArrowLeftIcon />
              Retour à la liste
            </Link>
          </Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-[var(--radius-surface-4xl)] border border-border/70 bg-card">
        <div className="p-5 sm:p-6">
          <CreateUserForm surface="embedded" showIntro={false} />
        </div>
      </div>
    </section>
  );
}
